import React from 'react'
import appConfig from '../../resource/appConfig.js'

const VIP = appConfig.reqStatuses.validationInProgress,
    VSW = appConfig.reqStatuses.validationSuccesswithErrors,
    FF = appConfig.reqStatuses.fulfilled,
    FwF = appConfig.reqStatuses.fulfilledWithFailures,
    VF = appConfig.reqStatuses.validationFailed,
    TO = appConfig.reqStatuses.timedOut,
    VS = appConfig.reqStatuses.validationSuccessful,
    S = appConfig.reqStatuses.submit

const requestStatusGuide = props => {
    const renderMessage = (currentRequest) => {
        return(
            <div aria-live="polite" aria-label="Instructions" tabIndex="0">
            {currentRequest.UPLOAD_TYPE && currentRequest.UPLOAD_TYPE !== '4' && currentRequest.REQ_STATUS === TO ?
               <p>There were unexpected errors during validation, and we were unable to process your file.
                   You can upload your data again by clicking on <b>Upload Full Replacement File.</b></p> : null
            }
            {currentRequest.UPLOAD_TYPE && currentRequest.UPLOAD_TYPE !== '4' && currentRequest.REQ_STATUS === FwF ?
               <p>Some of the records that have passed validation in your file are now available in AP Registration & Ordering.
                   You can click on <b>Download Request Log</b> to view the status of each record, including the reason that the records failed.
                   You can then make changes to those records and try again.
                   Once you have made changes, or if you need to upload additional records, click on <b>Create New Request</b>.
               </p> : null
            }
            {currentRequest.UPLOAD_TYPE && currentRequest.UPLOAD_TYPE !== '4' && currentRequest.REQ_STATUS === FF ?
               <p>All the records that have passed validation in your file are now available in AP Registration & Ordering.
                   You can click on <b>Download Request Log</b> to view the status of each record.
                   If you need to upload additional records, click on <b>Create New Request</b>.
               </p> : null
            }
            {currentRequest.UPLOAD_TYPE && currentRequest.UPLOAD_TYPE !== '4' && currentRequest.REQ_STATUS === VSW ?
               <p>Some records in your file passed validation, while other records in your file did not.
                   If your file had less than 500 records with errors, you can fix the errors online by clicking <b>Fix Errors and Warnings</b>.
                   You can also click on <b>Download Request Log</b> to view the errors.
                   Once you have modified your file to fix the errors, click on <b>Upload Full Replacement File</b> to upload the corrected file.
                   You can click on <b>Submit</b> to send the records without errors to AP Registration & Ordering; however, any records that have errors will not be sent.
               </p> : null
            }
            {currentRequest.UPLOAD_TYPE && currentRequest.UPLOAD_TYPE !== '4' && currentRequest.REQ_STATUS === VF ?
               <p>The records in your file all failed validation.
                   If your file had less than 500 failed records, you can fix the errors online by clicking on <b>Fix Errors and Warnings</b>.
                   You can also click on <b>Download Request Log</b> to view the errors.
                   Once you have modified your file to fix the errors, click on <b>Upload Full Replacement File</b> to upload the corrected file.
               </p> : null
            }
            {currentRequest.UPLOAD_TYPE && currentRequest.UPLOAD_TYPE !== '4' && currentRequest.REQ_STATUS === VIP ?
               <p>Your file is currently undergoing validation.  Please check back later to see the results of the file validation.</p> : null
            }
            {currentRequest.UPLOAD_TYPE && currentRequest.UPLOAD_TYPE !== '4' && currentRequest.REQ_STATUS === S ?
               <p>You have submitted the records that have passed validation to AP Registration & Ordering.  Please check back later to see the results.</p> : null
            }
            {currentRequest.UPLOAD_TYPE && currentRequest.UPLOAD_TYPE !== '4' && currentRequest.REQ_STATUS === VS ?
               <p>All the records in your file passed validation.  Click on <b>Submit</b> to send the records to AP Registration & Ordering.</p> : null
            }
            {((currentRequest.UPLOAD_TYPE && currentRequest.UPLOAD_TYPE !== '4' && (currentRequest.REQ_STATUS === VF || currentRequest.REQ_STATUS === VSW) && (currentRequest.ERROR_COUNT && currentRequest.ERROR_COUNT > appConfig.erroneousRowsCountLimit))) ?
                <p>Please download the Request Log File to address any error and warning in your data. Then you can re-upload the file through Upload Full Replacement File link to revalidate your data.</p> : null
            }
        </div>
        )
    }
    return(renderMessage(props.currentRequest))

}
export default requestStatusGuide